import { z } from 'zod';

const optionalTrimmedString = z.preprocess(
  v => (typeof v === 'string' && v.trim() === '' ? undefined : v),
  z.string().trim().optional(),
);

export const AgencyBranchInputSchema = z.object({
  name: z.string().trim().min(1, 'Required'),
  addressLine1: z.string().trim().min(1, 'Required'),
  addressLine2: optionalTrimmedString,
  addressLine3: optionalTrimmedString,
  city: z.string().trim().min(1, 'Required'),
  postcode: optionalTrimmedString,
  country: z.string().trim().min(1, 'Required'),
  contactGivenName: optionalTrimmedString,
  contactFamilyName: optionalTrimmedString,
  contactEmail: z.preprocess(
    v => (typeof v === 'string' && v.trim() === '' ? undefined : v),
    z.string().trim().email('Email is not valid').optional(),
  ),
});

export type AgencyBranchInput = z.infer<typeof AgencyBranchInputSchema>;

export interface IAgencyBranch extends AgencyBranchInput {
  id: string;
}
